import { z } from "zod";

export const TOKEN_NAME_REGEX = /^[a-z][a-z0-9]*(\.[a-z0-9]+)+$/;

export const TokenNameSchema = z
	.string()
	.regex(
		TOKEN_NAME_REGEX,
		"Token name must be lowercase dot-separated (e.g. text.primary)",
	);

export const TokenRefSchema = z
	.object({
		token: TokenNameSchema,
	})
	.strict();
export type TokenRef = z.infer<typeof TokenRefSchema>;

export const isTokenRef = (value: unknown): value is TokenRef =>
	typeof value === "object" &&
	value !== null &&
	"token" in (value as Record<string, unknown>) &&
	typeof (value as { token: unknown }).token === "string";
